<a data-test="d4Z6Gy69" class="dropdown__menu-link">{{ link }}</a>
<div
  data-test="fA1tvjOy"
  class="dropdown dropdown_child"
  infiniteScroll
  [infiniteScrollDisabled]="!url || !infiniteScroll"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  [infiniteScrollContainer]="scrollElem"
  (scrolled)="moreOptions()"
>
  <div data-test="PkVrOzke" class="dropdown__wrap">
    <div data-test="jjFehvwd" class="dropdown__search">
      <input
        data-test="-TzORKrE"
        #input
        [(ngModel)]="model"
        class="dropdown__input input input_xs"
        [attr.size]="size || null"
        [ngClass]="inputClasses || ''"
        [attr.placeholder]="placeholder"
        (input)="onFilter(input.value)"
        (keydown)="changeChosenByKeyboard($event)"
        (focus)="resetFilter(); focus($event)"
        (blur)="resetLabel()"
        type="text"
      />
    </div>
    <ul
      data-test="jG5FSBqP"
      class="dropdown__menu"
      data-simplebar="init"
      #listElem
      style="max-height: 150px"
    >
      <div data-test="irNMLsDn" class="simplebar-scroll-content" #scrollElem>
        <div data-test="76GdD0lP" class="simplebar-content">
          <li
            data-test="VuptpsAC"
            class="dropdown__menu-item"
            *ngIf="input.value && canAdd"
            (mousedown)="addNew(input.value, url)"
          >
            <a data-test="fZ6HVnte" class="dropdown__menu-link">
              <i data-test="xYTxoSHW" class="icon material-icons md-16">add</i>
              <span data-test="5ZPVTH4w">Add new {{ itemName }}</span>
            </a>
          </li>
          <li
            data-test="4Ixi6C8O"
            class="dropdown__menu-item"
            *ngFor="let option of options"
            [class.active]="isChosenByKeyboard(option)"
            [class.checked]="isChosen(option)"
          >
            <a
              data-test="bmgWeBzn"
              class="dropdown__menu-link"
              (mousedown)="selectValue(option)"
            >
              {{ labelKey ? option[labelKey] : option }}
            </a>
          </li>
        </div>
      </div>
    </ul>
  </div>
</div>
